import { PayTypeMap } from "./variable-data.types";

export const transformPayType = (value: string): string => {
    const map: PayTypeMap = {
        'MENS': 'Mensual',
        'BIME': 'Bimestral',
        'TRIM': 'Trimestral',
        'SEME': 'Semestral',
        'ANUA': 'Anual',
        'UNIC': 'Único',
        'MENSUAL': 'MENS',
        'BIMESTRAL': 'BIME',
        'TRIMESTRAL': 'TRIM',
        'SEMESTRAL': 'SEME',
        'ANUAL': 'ANUA',
        'PAGO ÚNICO': 'ANUA',
        'ÚNICO': 'UNIC',
    };
    return map[value.toUpperCase()] || value;
}